/**
 * Footer Component - Site footer with legal links and navigation
 */

import { Shield, ExternalLink } from 'lucide-react'
import '../footer.css'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId)
    if (element) {
      const offset = 80
      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset - offset

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })

      // If it's the privacy section, trigger expansion
      if (sectionId === 'privacy') {
        // Add hash to URL to trigger auto-expansion
        window.location.hash = 'privacy'
      }
      // If it's the about section, trigger expansion
      if (sectionId === 'about') {
        // Add hash to URL to trigger auto-expansion
        window.location.hash = 'about'
      }
      // If it's the contact section, trigger expansion
      if (sectionId === 'contact') {
        // Add hash to URL to trigger auto-expansion
        window.location.hash = 'contact'
      }
    }
  }

  return (
    <footer className="site-footer">
      <div className="footer-container">
        
        {/* Main Footer Content */}
        <div className="footer-content">
          
          {/* Brand Section */}
          <div className="footer-section brand-section">
            <div className="footer-brand">
              <Shield size={24} color="#ff6b35" />
              <span className="brand-name">Zero Debt Journey</span>
            </div>
            <p className="footer-tagline">
              Free debt payoff calculator helping you plan your path to financial freedom.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul className="footer-links">
              <li>
                <button onClick={() => scrollToSection('calculator')}>
                  Debt Calculator
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('how-it-works')}>
                  How It Works
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('education')}>
                  Education
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('faq')}>
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div className="footer-section">
            <h3>Legal</h3>
            <ul className="footer-links">
              <li>
                <button onClick={() => scrollToSection('about')}>
                  About
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')}>
                  Contact
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('privacy')}>
                  Privacy Policy
                </button>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div className="footer-section">
            <h3>Important Disclaimer</h3>
            <p className="disclaimer">
              This calculator is for educational purposes only. We are not financial advisors. 
              Results are estimates based on your inputs and may not reflect your actual payoff 
              timeline. Consult a financial professional for personalized advice.
            </p>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">
              © {currentYear} Zero Debt Journey. All rights reserved.
            </p>
            <div className="footer-bottom-links">
              <button onClick={() => scrollToSection('privacy')}>
                Privacy Policy
              </button>
              <span className="separator">•</span>
              <a 
                href="https://policies.google.com/privacy" 
                target="_blank" 
                rel="noopener noreferrer"
                className="external-link"
              >
                Google Privacy
                <ExternalLink size={12} />
              </a>
            </div>
          </div>
        </div>

      </div>
    </footer>
  )
}

export default Footer
